// src/components/Footer.js
import React, { useEffect, useState } from 'react';

const COOKIE_NOTICE_KEY = 'stb_cookie_notice_accepted';

const getCookieNoticeAccepted = () => {
  try {
    return localStorage.getItem(COOKIE_NOTICE_KEY) === 'true';
  } catch {
    return true;
  }
};

const setCookieNoticeAccepted = () => {
  try {
    localStorage.setItem(COOKIE_NOTICE_KEY, 'true');
  } catch {
    // Ignore storage errors so the footer remains usable in restricted browsers.
  }
};

const Footer = () => {
  const [cookieVisible, setCookieVisible] = useState(false);

  useEffect(() => {
    if (!getCookieNoticeAccepted()) {
      setCookieVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    setCookieNoticeAccepted();
    setCookieVisible(false);
  };

  return (
    <>
      <section className="container footer-modern-section">
        <footer className="footer-modern">
          <div className="footer-modern-brand">
            <a href="/" className="footer-modern-logo-link">
              <img
                className="footer-modern-logo"
                src={process.env.PUBLIC_URL + '/images/logo/shoptop_logo_3d_icon_transparent.png'}
                alt="SHOPTOP BRANDS"
                loading="lazy"
                decoding="async"
              />
            </a>

            <p>
              SHOPTOP BRANDS — выкуп оригинальных товаров из США и Европы.
            </p>
          </div>

          <div className="footer-modern-info">
            <h3>Реквизиты</h3>
            <p>ИП Чеботарева Ирина Анатольевна</p>
            <p>ИНН 540860074774</p>
            <p>ОГРНИП 325547600018650</p>
          </div>

          <div className="footer-modern-links">
            <h3>Документы</h3>
            <a href="/privacy">Политика конфиденциальности</a>
            <a
              href="/oferta"
            >
              Договор оферты
            </a>
          </div>

          <div className="footer-modern-contacts">
            <h3>Связаться</h3>

            <div className="footer-modern-socials">
              <a
                href="https://t.me/Shoptopbuyer"
                target="_blank"
                rel="noreferrer"
                aria-label="Telegram"
              >
                <img
                  src={process.env.PUBLIC_URL + '/images/svg/telegram.svg'}
                  alt=""
                  loading="lazy"
                  decoding="async"
                />
              </a>

              <a
                href="https://max.ru/u/f9LHodD0cOJjibeQdLaN1HkU7twja89JfpuGsU8p2lFu6TOKe4IPrrruCrA"
                target="_blank"
                rel="noreferrer"
                aria-label="MAX"
              >
                <span>MAX</span>
              </a>

              <a
                href="https://api.whatsapp.com/send?phone=79130117070"
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
              >
                <img
                  src={process.env.PUBLIC_URL + '/images/svg/whatsapp.svg'}
                  alt=""
                  loading="lazy"
                  decoding="async"
                />
              </a>
            </div>
          </div>

          <div className="footer-modern-bottom">
            <span>© SHOPTOP BRANDS</span>
            <span>Все права защищены</span>
          </div>
        </footer>
      </section>

      {cookieVisible && (
        <div className="cookie-notice">
          <p>
            Сайт использует cookie и технические данные для корректной работы форм,
            оплаты и улучшения сервиса.
          </p>

          <button type="button" onClick={acceptCookies}>
            Понятно
          </button>
        </div>
      )}
    </>
  );
};

export default Footer;
